// Pieces that vary in size (e.g. hides) sell by the piece at a price for an
// average piece — `approx_sqft` on the product option. Before the customer is
// charged, an admin measures the pieces and re-prices the order line.

// "20", "42.5" — sizes to one decimal place.
export const formatSqft = (value) => {
  const size = Number(value);
  if (!Number.isFinite(size) || size <= 0) return '';
  return String(Math.round(size * 10) / 10);
};

// Price per square foot implied by a piece price and the average piece size.
export const pricePerSqft = (piecePrice, approxSqft) => {
  const price = Number(piecePrice);
  const size = Number(approxSqft);
  if (!(price > 0) || !(size > 0)) return null;
  return price / size;
};
